var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaidTestRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m385-424 35-122-97-60h121l36-132 36 132h121l-96 60 35 122-96-75-95 75ZM262-84v-283.45Q223-408 202.5-460.5T182-570q0-124 87-211t211-87q124 0 211 87t87 211q0 57-19.5 109.5T698-367.45V-84l-218-68-218 68Zm218.24-242Q582-326 653-397.24q71-71.23 71-173Q724-672 652.76-743q-71.23-71-173-71Q378-814 307-742.76q-71 71.23-71 173Q236-468 307.24-397q71.23 71 173 71ZM316-163l164-43 164 43v-160q-36 26-77.32 38.5Q525.35-272 480-272q-45.35 0-86.68-12.5Q352-297 316-323v160Zm164-80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidTestRequest);
export default __webpack_public_path__ + "static/media/paid-test-request.d76b43c64963f07151e9873892c340b2.svg";
export { ForwardRef as ReactComponent };